
import React from 'react';
import { motion } from 'motion/react';
import { Shield, Globe } from 'lucide-react';

interface LockOverlayProps {
  isOnline: boolean;
  hasFetched: boolean;
}

export const LockOverlay: React.FC<LockOverlayProps> = ({ isOnline, hasFetched }) => {
  const isStudioLocked = !isOnline || !hasFetched;
  if (!isStudioLocked) return null;

  return (
    <div className="absolute inset-0 z-[2000] backdrop-blur-[0.5px] bg-white/5 flex flex-col items-center justify-center p-12 text-center">
      <motion.div 
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          className="bg-white p-8 rounded-[2.5rem] shadow-2xl border border-zinc-950/10 flex flex-col items-center max-w-sm"
      >
          <div className="w-16 h-16 bg-red-50 rounded-2xl flex items-center justify-center mb-6">
              {isOnline ? <Shield className="w-8 h-8 text-red-500 animate-pulse" /> : <Globe className="w-8 h-8 text-zinc-400 animate-bounce" />}
          </div>
          <h3 className="text-lg font-black uppercase tracking-tight mb-2">
              {isOnline ? 'Security Sync Required' : 'Connection Lost'}
          </h3>
          <p className="text-xs font-bold text-zinc-500 mb-8 leading-relaxed uppercase tracking-wider">
              {isOnline 
                  ? 'We are establishing a secure connection to the studio engine. Please wait.' 
                  : 'The Creator Studio requires an active internet connection to verify your permissions and cloud sync.'}
          </p>
          {!isOnline && (
              <div className="text-[10px] font-black uppercase tracking-[0.2em] px-4 py-2 bg-neon-cyan text-white rounded-full shadow-lg shadow-cyan-500/20">
                  Offline mode restricted
              </div>
          )}
      </motion.div>
    </div>
  );
};
